import React from "react";
import PropTypes from "prop-types";
import {
	SectionCard,
	PeopleSection,
	AttachmentsSectionCard,
	ValueText,
	Lookup,
} from "frame/components";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { formatDate, formatDateTime, useTerminology } from "utils";

const useStyles = makeStyles((theme) => ({
	emailLogRow: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(0.75, 0),
		borderBottom: `1px solid ${theme.palette.divider}`,
		"&:last-child": {
			borderBottom: "none",
		},
	},
	emailAddress: {
		fontWeight: 500,
	},
	sentAt: {
		color: theme.palette.text.secondary,
		fontSize: "0.85rem",
		whiteSpace: "nowrap",
		marginLeft: theme.spacing(2),
	},
	noLog: {
		color: theme.palette.text.secondary,
		fontStyle: "italic",
	},
}));

const ReadOnlyForm = ({ values }) => {
	const classes = useStyles();
	const { siteLabel } = useTerminology();
	const notes = values.notes || {};
	const emailLog = values.emailLog || [];

	return (
		<>
			<SectionCard>
				<Grid container spacing={2}>
					<Grid item sm={6} xs={12}>
						<ValueText
							label="Title"
							value={values.title}
							options={{ bold: true }}
						/>
					</Grid>
					<Grid item sm={6} xs={12}>
						<ValueText
							label={siteLabel}
							value={
								<Lookup
									id={values.siteId}
									resource="sites"
									attribute="siteName"
								/>
							}
							options={{ bold: true }}
						/>
					</Grid>
					<Grid item sm={6} xs={12}>
						<ValueText
							label="Date"
							value={formatDate(values.createdAt)}
							options={{ bold: true }}
						/>
					</Grid>
				</Grid>
			</SectionCard>

			<SectionCard title="People">
				<PeopleSection
					people={values.people}
					otherPeople={values.otherPeople}
				/>
			</SectionCard>

			<SectionCard title="Meeting Notes">
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<ValueText
							label="Operational Issues"
							value={notes.operationalIssues}
							options={{ bold: true }}
						/>
					</Grid>
					<Grid item xs={12}>
						<ValueText
							label="General Issues Discussed"
							value={notes.generalIssuesDiscussed}
							options={{ bold: true }}
						/>
					</Grid>
				</Grid>
			</SectionCard>

			<AttachmentsSectionCard values={values} />

			<SectionCard title="Email Log">
				{emailLog.length === 0 ? (
					<Typography className={classes.noLog} variant="body2">
						No emails sent yet.
					</Typography>
				) : (
					emailLog.map((entry, index) => (
						<div key={index} className={classes.emailLogRow}>
							<div>
								{entry.fullName && (
									<Typography className={classes.emailAddress} variant="body2">
										{entry.fullName}
									</Typography>
								)}
								<Typography variant="body2" color={entry.fullName ? "textSecondary" : "textPrimary"}>
									{entry.email}
								</Typography>
							</div>
							<Typography className={classes.sentAt} variant="body2">
								{formatDateTime(entry.sentAt)}
							</Typography>
						</div>
					))
				)}
			</SectionCard>
		</>
	);
};

ReadOnlyForm.propTypes = {
	values: PropTypes.object.isRequired,
};

export default ReadOnlyForm;
